import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _Spin from "choerodon-ui/lib/spin";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _uniq from "lodash/uniq";
import _isBoolean from "lodash/isBoolean";
// 加载微前端模块
import pathToRegexp from 'path-to-regexp';
import uuid from 'uuid/v4';
import React from 'react';
import { getConfigStore } from "../../index";
import getMicroPublicUrl, { getExternalMicroPublicUrlList } from "../../getMicroPublicUrlPrefix";
import { tabListen } from "hzero-front/lib/utils/menuTab"; // import './loadingMicroStyle.less';

window.getMicroPublicUrlPrefix = getMicroPublicUrl; // const delay = (timeout) =>
//   new Promise((resolve) => {
//     setTimeout(() => {
//       resolve(null);
//     }, timeout);
//   });

export var LOCATION_CHANGE_ACTION_TYPE = '@@router/LOCATION_CHANGE';
export var NAMESPACE = 'microModule';
export var UPDATE_MICRO_STATUS = 'microModule/UPDATE_MICRO_STATUS';
export var UPDATE_STATE = 'microModule/UPDATE_MICRO_STATE';
export var START_LISTEN_PATHNAME = 'microModule/START_LISTEN_PATHNAME';
export var LOAD_MICRO_MODULE_FROM_PATHNAME = 'microModule/LOAD_MICRO_MODULE_FROM_PATHNAME'; // export const delay = (timeout = 0) => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve(null);
//     }, timeout);
//   });
// };

var fetchJsonp = function () {
  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };
  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }
  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }
  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }
  function _fetchJsonp(_url) {
    var _arguments = arguments;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function (options) {
      var options = _arguments.length <= 1 || _arguments[1] === undefined ? {} : _arguments[1]; // to avoid param reassign

      var url = _url;
      var timeout = options.timeout || defaultOptions.timeout;
      var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;
      var timeoutId = undefined;
      return new Promise(function (resolve, reject) {
        var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
        var scriptId = jsonpCallback + '_' + callbackFunction;
        window[callbackFunction] = function (response) {
          resolve({
            ok: true,
            // keep consistent with fetch API
            json: function json() {
              return Promise.resolve(response);
            }
          });
          if (timeoutId) clearTimeout(timeoutId);
          removeScript(scriptId);
          clearFunction(callbackFunction);
        };
        var jsonpScript = document.createElement('script');
        jsonpScript.setAttribute('src', '' + url);
        if (options.charset) {
          jsonpScript.setAttribute('charset', options.charset);
        }
        jsonpScript.id = scriptId;
        document.getElementsByTagName('head')[0].appendChild(jsonpScript);
        timeoutId = setTimeout(function () {
          reject(new Error('JSONP request to ' + _url + ' timed out'));
          clearFunction(callbackFunction);
          removeScript(scriptId);
          window[callbackFunction] = function () {
            clearFunction(callbackFunction);
          };
        }, timeout); // Caught if got 404/500

        jsonpScript.onerror = function () {
          reject(new Error('JSONP request to ' + _url + ' failed'));
          clearFunction(callbackFunction);
          removeScript(scriptId);
          if (timeoutId) clearTimeout(timeoutId);
        };
      });
    }(options);
  }
  return _fetchJsonp;
}();
var handleLoadMicroPending = null;
var handleLoadMicroing = false;
var bootstrap = function bootstrap() {
  var dvaApp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.dvaApp;
  var FETCH_JSONP_TIMEOUT = +"".concat(process.env.FETCH_JSONP_TIMEOUT || 5 * 12000); // 挂载框架api到全局对象上 ， 子模块通过 externals 依赖引入

  window.React = require('react');
  window.ReactDOM = require('react-dom');
  window.ReactRouter = require('react-router');
  window.ReactRouterDom = require('react-router-dom'); // const Vue = require('vue');
  // (window as any).Vue = Vue.default || Vue;

  window.regeneratorRuntime = require('regenerator-runtime');
  window._hzero_cards_customize_api = require("../../utils/cards");
  window.hzeroIcons = require('hzero-front/lib/components/Icons'); // hzero-front/lib/components/Icons

  window.axios = require('axios');
  window.mobx = require('mobx');
  window.codemirror = require('codemirror');
  window.classnames = require('classnames');
  window.moment = require('moment');
  window.lodash = require('lodash'); // (window as any).ReactBeautifulDnd = require('react-beautiful-dnd');

  window.styledComponents = require('styled-components');
  window.hzeroBasicPageBaseRouter = require('hzero-front/lib/routes');
  window.uedContainer = require('@hzero-front-ui/cfg/lib/components/Container');
  window.hzeroIoutils = require('hzero-front/lib/utils/iocUtils');
  window.hzeroC7nUiConfig = require('hzero-front/lib/utils/c7nUiConfig');
  window.hzeroFrontUiCfg = require('@hzero-front-ui/cfg');
  window.hzeroMapCustomize = require('hzero-front/lib/utils/customize');
  window.hzeroFormatterCollections = require('hzero-front/lib/utils/intl/formatterCollections');
  window.hzeroMenuTab = require('hzero-front/lib/utils/menuTab');
  window.hzeroNProgress = require('hzero-front/lib/components/NProgress');
  window.hzeroLoadingBar = require('hzero-front/lib/components/NProgress/LoadingBar');
  window.hzeroUi = require('hzero-ui/lib');
  window.dva = require('dva');
  window.reactIntlUniversal = require('react-intl-universal');
  window.choerodonUi = require('choerodon-ui/lib');
  window.choerodonUiPro = require('choerodon-ui/pro/lib');
  window.choerodonUiPro_Record = require('choerodon-ui/pro/lib/data-set/Record');
  window.choerodonUiPro_FormField = require('choerodon-ui/pro/lib/field/FormField');
  var setMicroLoading = getConfigStore()['setMicroLoading'];
  var isLoadMicro = getConfigStore()['isLoadMicro'];
  var loadedMap = {};
  var loadScripts = function loadScripts(url) {
    if (loadedMap[url]) {
      return Promise.resolve(null);
    } else {
      loadedMap[url] = 1;
    }
    return new Promise(function (resolve, reject) {
      var element = document.createElement('script');
      element.src = url;
      element.type = 'text/javascript';
      element.async = true;
      element.onload = function () {
        document.head.removeChild(element); // console.log(`Dynamic Script Loaded: ${args.url}`)

        resolve(null);
      };
      element.onerror = function (e) {
        // console.error(`Dynamic Script Error: ${args.url}`)
        document.head.removeChild(element);
        reject(e || new Error("Dynamic Script Error: ".concat(url)));
      };
      document.head.appendChild(element);
    });
  };
  var execJsOrCss = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(packageName, microModuleScriptMap) {
      var indexAssets, basePath, scripts, styles;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              indexAssets = microModuleScriptMap[packageName].customizeAssets;
              if (!(!indexAssets || indexAssets.length === 0)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", {});
            case 3:
              if (typeof indexAssets === 'string') {
                indexAssets = [indexAssets];
              }
              basePath = getMicroPublicUrl({
                moduleName: packageName,
                microModuleScriptMap: microModuleScriptMap
              });
              scripts = indexAssets.filter(function (r) {
                return r.replace(/\?[\w\-_]+=.*$/, '').endsWith('.js');
              }).map(function (r) {
                return "".concat(basePath).concat(r);
              });
              styles = indexAssets.filter(function (r) {
                return r.replace(/\?[\w\-_]+=.*$/, '').endsWith('.css');
              }).map(function (r) {
                return "".concat(basePath).concat(r);
              });
              styles.forEach(function (styleUrl) {
                var styleEle = document.createElement('link');
                styleEle.setAttribute('rel', 'stylesheet');
                styleEle.setAttribute('href', styleUrl);
                document.head.insertBefore(styleEle, document.head.children[0]);
              });
              scripts.map(loadScripts); // Promise.all(jsPromises).then((freeArray) => {
              //   freeArray.forEach((fn: any) => {
              //     if (typeof fn === 'function') {
              //       fn();
              //     }
              //   });
              // });

              return _context.abrupt("return", {});
            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function execJsOrCss(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var fetchData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(packageName, microModuleScriptMap) {
      var packageInfo, indexAssets, basePath, scripts, styles, styleEles, data, res, handleLoadMicroError;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              packageInfo = microModuleScriptMap[packageName];
              if (packageInfo) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", {});
            case 3:
              indexAssets = packageInfo.indexAssets;
              basePath = getMicroPublicUrl({
                moduleName: packageName,
                microModuleScriptMap: microModuleScriptMap
              });
              if (indexAssets) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", {});
            case 7:
              scripts = indexAssets.filter(function (r) {
                return r.replace(/\?[\w\-_]+=.*$/, '').endsWith('.js');
              }).map(function (r) {
                return "".concat(basePath).concat(r);
              });
              styles = indexAssets.filter(function (r) {
                return r.replace(/\?[\w\-_]+=.*$/, '').endsWith('.css');
              }).map(function (r) {
                return "".concat(basePath).concat(r);
              });
              styleEles = [];
              styles.forEach(function (styleUrl) {
                var styleEle = document.createElement('link');
                styleEle.setAttribute('rel', 'stylesheet');
                styleEle.setAttribute('href', styleUrl);
                document.head.insertBefore(styleEle, document.head.children[0]);
                styleEles.push(styleEle);
              });
              _context2.prev = 11;
              scripts.slice(1).map(loadScripts);
              _context2.next = 15;
              return fetchJsonp("".concat(scripts[0]), {
                timeout: FETCH_JSONP_TIMEOUT,
                jsonpCallbackFunction: "hzeroJsonp_packages/".concat(packageName, "-main"),
                charset: 'UTF-8'
              }).then(function (r) {
                return r.json();
              });
            case 15:
              data = _context2.sent;
              if (data.getRouterData.beforeLoad) {
                data.getRouterData.beforeLoad(dvaApp);
              }
              ""; // await delay(8000);

              _context2.next = 20;
              return data.getRouterData(dvaApp);
            case 20:
              res = _context2.sent;
              return _context2.abrupt("return", res);
            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](11);
              styleEles.forEach(function (styleEle) {
                styleEle.remove();
              });
              console.error(_context2.t0);
              handleLoadMicroError = getConfigStore()['handleLoadMicroError'];
              if (handleLoadMicroError && typeof handleLoadMicroError === 'function') {
                handleLoadMicroError({
                  packageName: packageName,
                  microModuleScriptMap: microModuleScriptMap
                });
              }
            case 30:
              return _context2.abrupt("return", {});
            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[11, 24]]);
    }));
    return function fetchData(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
  var getMicroModuleRouters = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(opts) {
      var microModuleScriptMap, microModules, allPromise, allMicroRoutes, mergeMicroRoutes, routerData;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              microModuleScriptMap = opts.microModuleScriptMap, microModules = opts.microModules;
              if (!(microModules.length === 0)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return", {});
            case 3:
              allPromise = microModules.map(function (packageName) {
                return fetchData(packageName, microModuleScriptMap);
              });
              _context3.next = 6;
              return Promise.all(allPromise);
            case 6:
              allMicroRoutes = _context3.sent;
              mergeMicroRoutes = allMicroRoutes.reduce(function (mergeObj, microRouteItem) {
                var retObj = _objectSpread({}, mergeObj);
                Object.keys(microRouteItem).forEach(function (path) {
                  var temp = null;
                  if (retObj[path]) {
                    temp = retObj[path];
                    if ((retObj[path].priority || 0) > (microRouteItem[path].priority || 0)) {
                      // if (
                      //   temp &&
                      //   (temp.index === false || microRouteItem[path].index === false)
                      // ) {
                      //   retObj[path].index = false;
                      // }
                      return;
                    }
                  } // if (retObj[path]) {
                  //   console.warn(
                  //     microRouteItem[path],
                  //     '  == (路由覆盖) =>  ',
                  //     retObj[path]
                  //   );
                  // }

                  retObj[path] = microRouteItem[path]; // if (temp && (temp.index === false || retObj[path].index === false)) {
                  //   retObj[path].index = false;
                  // }
                });

                return retObj;
              }, {});
              routerData = {}; // The route matches the menu

              Object.keys(mergeMicroRoutes).forEach(function (path) {
                if (routerData[path]) {
                  if ((routerData[path].priority || 0) > (mergeMicroRoutes[path].priority || 0)) {
                    return;
                  }
                }
                var router = mergeMicroRoutes[path]; // Regular match item name
                // eg.  router /user/:id === /user/chen
                // @ts-ignore

                var pathRegexp = pathToRegexp(path, undefined, {
                  end: router.exact
                });
                router = _objectSpread(_objectSpread({}, router), {}, {
                  name: router.name,
                  // tab 用到的数据
                  pathRegexp: pathRegexp,
                  title: router.title,
                  icon: router.icon,
                  closable: _isBoolean(router.closable) ? router.closable : true,
                  path: path,
                  // tab 用到的数据
                  authority: router.authority
                });
                routerData[path] = router;
              });
              return _context3.abrupt("return", routerData);
            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function getMicroModuleRouters(_x5) {
      return _ref3.apply(this, arguments);
    };
  }();
  var loadedCustomizeConfigMap = {};
  var loadCustomizeConfig = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(opts) {
      var microModuleScriptMap, packageNames, _iterator, _step, packageName;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              microModuleScriptMap = opts.microModuleScriptMap, packageNames = opts.packageNames;
              if (packageNames) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              _iterator = _createForOfIteratorHelper(packageNames);
              _context4.prev = 4;
              _iterator.s();
            case 6:
              if ((_step = _iterator.n()).done) {
                _context4.next = 20;
                break;
              }
              packageName = _step.value;
              _context4.prev = 8;
              if (!loadedCustomizeConfigMap[packageName]) {
                _context4.next = 11;
                break;
              }
              return _context4.abrupt("continue", 18);
            case 11:
              execJsOrCss(packageName, microModuleScriptMap);
              loadedCustomizeConfigMap[packageName] = true;
              _context4.next = 18;
              break;
            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](8);
              console.error(_context4.t0);
            case 18:
              _context4.next = 6;
              break;
            case 20:
              _context4.next = 25;
              break;
            case 22:
              _context4.prev = 22;
              _context4.t1 = _context4["catch"](4);
              _iterator.e(_context4.t1);
            case 25:
              _context4.prev = 25;
              _iterator.f();
              return _context4.finish(25);
            case 28:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[4, 22, 25, 28], [8, 15]]);
    }));
    return function loadCustomizeConfig(_x6) {
      return _ref4.apply(this, arguments);
    };
  }();
  var getMicroModuleMapConfig = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var basePath, microConfigMap, getMicroConfig, externalMicroPublicUrlList, microLoadInterceptor, allowLoadPackList, newMicroLoadedMap;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              basePath = getMicroPublicUrl(); // 获取子模块的config

              microConfigMap = {};
              _context7.prev = 2;
              getMicroConfig = getConfigStore()['getMicroConfig'];
              if (!(getMicroConfig && typeof getMicroConfig === 'function')) {
                _context7.next = 10;
                break;
              }
              _context7.next = 7;
              return getMicroConfig({
                basePath: basePath
              });
            case 7:
              microConfigMap = _context7.sent;
              _context7.next = 13;
              break;
            case 10:
              _context7.next = 12;
              return fetch("".concat(basePath, "packages/microConfig.json")).then(function (r) {
                return r.json();
              });
            case 12:
              microConfigMap = _context7.sent;
            case 13:
              _context7.next = 18;
              break;
            case 15:
              _context7.prev = 15;
              _context7.t0 = _context7["catch"](2);
              console.error(_context7.t0);
            case 18:
              _context7.next = 20;
              return Promise.all(Object.keys(microConfigMap).map( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(packageName) {
                  var packageInfo, _packageInfo$publicUr, publicUrl, extPackageInfo;
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          packageInfo = microConfigMap[packageName];
                          if (!(packageInfo.external && packageInfo.publicUrl)) {
                            _context5.next = 13;
                            break;
                          }
                          _context5.prev = 2;
                          publicUrl = ((_packageInfo$publicUr = packageInfo.publicUrl) === null || _packageInfo$publicUr === void 0 ? void 0 : _packageInfo$publicUr.endsWith('/')) ? packageInfo.publicUrl : "".concat(packageInfo.publicUrl, "/");
                          _context5.next = 6;
                          return fetchJsonp("".concat(publicUrl, "packages/").concat(packageName, "/package.js"), {
                            jsonpCallbackFunction: "hzeroJsonp_packages/".concat(packageName, "-package"),
                            timeout: FETCH_JSONP_TIMEOUT,
                            charset: 'UTF-8'
                          }).then(function (r) {
                            return r.json();
                          });
                        case 6:
                          extPackageInfo = _context5.sent;
                          microConfigMap[packageName] = _objectSpread(_objectSpread({}, extPackageInfo), microConfigMap[packageName]);
                          _context5.next = 13;
                          break;
                        case 10:
                          _context5.prev = 10;
                          _context5.t0 = _context5["catch"](2);
                          console.error(_context5.t0);
                        case 13:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, null, [[2, 10]]);
                }));
                return function (_x7) {
                  return _ref6.apply(this, arguments);
                };
              }()));
            case 20:
              // 获取微前端的config
              externalMicroPublicUrlList = getExternalMicroPublicUrlList();
              if (!(externalMicroPublicUrlList.length > 0)) {
                _context7.next = 24;
                break;
              }
              _context7.next = 24;
              return Promise.all(externalMicroPublicUrlList.map( /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(extBasePath) {
                  var extMicroConfigMap;
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          if (!(extBasePath && extBasePath !== basePath)) {
                            _context6.next = 11;
                            break;
                          }
                          _context6.prev = 1;
                          _context6.next = 4;
                          return fetch("".concat(extBasePath, "packages/microConfig.json")).then(function (r) {
                            return r.json();
                          });
                        case 4:
                          extMicroConfigMap = _context6.sent;
                          Object.keys(extMicroConfigMap).forEach(function (packageName) {
                            if (!microConfigMap[packageName]) {
                              microConfigMap[packageName] = _objectSpread({
                                publicUrl: extBasePath
                              }, extMicroConfigMap[packageName]);
                            }
                          });
                          _context6.next = 11;
                          break;
                        case 8:
                          _context6.prev = 8;
                          _context6.t0 = _context6["catch"](1);
                          console.error(_context6.t0);
                        case 11:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6, null, [[1, 8]]);
                }));
                return function (_x8) {
                  return _ref7.apply(this, arguments);
                };
              }()));
            case 24:
              microLoadInterceptor = getConfigStore()['microLoadInterceptor'];
              if (!microLoadInterceptor) {
                _context7.next = 32;
                break;
              }
              _context7.next = 28;
              return microLoadInterceptor(Object.values(microConfigMap));
            case 28:
              allowLoadPackList = _context7.sent;
              newMicroLoadedMap = {};
              allowLoadPackList.forEach(function (packageInfo) {
                newMicroLoadedMap[packageInfo.name] = packageInfo;
              });
              microConfigMap = newMicroLoadedMap;
            case 32:
              window.microModuleScriptMap = microConfigMap;
              return _context7.abrupt("return", microConfigMap);
            case 34:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[2, 15]]);
    }));
    return function getMicroModuleMapConfig() {
      return _ref5.apply(this, arguments);
    };
  }();
  var overloadRouterData = function overloadRouterData(routerData, addRouterData) {
    var newRouterData = _objectSpread({}, routerData);
    Object.keys(addRouterData).forEach(function (newRouterPath) {
      var temp = null;
      if (routerData[newRouterPath]) {
        temp = newRouterData[newRouterPath];
        if ((routerData[newRouterPath].priority || 0) > (addRouterData[newRouterPath].priority || 0)) {
          // if (
          //   temp &&
          //   (temp.index === false ||
          //     addRouterData[newRouterPath].index === false)
          // ) {
          //   newRouterData[newRouterPath].index = false;
          // }
          return;
        }
      } // 在覆盖前，被覆盖项若是父路由，则对父路由下的子路由清除loadIndex排序

      if (temp && temp.components instanceof Array && temp.components.length > 0) {
        temp.components.forEach(function (sub) {
          if (newRouterData[sub.path]) {
            delete newRouterData[sub.path].loadIndex;
          }
        });
      } // if (routerData[newRouterPath]) {
      //   console.warn(
      //     addRouterData[newRouterPath],
      //     '  == (路由覆盖) =>  ',
      //     routerData[newRouterPath]
      //   );
      // }

      newRouterData[newRouterPath] = addRouterData[newRouterPath]; // if (
      //   temp &&
      //   (temp.index === false || addRouterData[newRouterPath].index === false)
      // ) {
      //   newRouterData[newRouterPath].index = false;
      // }
    });

    Object.keys(newRouterData).forEach(function (newRouterPath) {
      var oldRoute = newRouterData[newRouterPath];
      if (oldRoute && oldRoute.components && oldRoute.components instanceof Array && oldRoute.components.length > 0) {
        oldRoute.loadIndex = oldRoute.loadIndex || 0;
        oldRoute.components.forEach(function (sub, index) {
          if (newRouterData[sub.path]) {
            newRouterData[sub.path].loadIndex = index + 1;
          }
        });
      }
    });
    return newRouterData; // hzero-front 的坑， RouterData 必须对象的 key 必须有顺序要求。所以我要做一下 key 排序。
    // todo: 但是这不是一个稳定的解决方案。如果在其他浏览器环境中 object key 顺序自动随机。 还是会导致 bug;
    // return Object.keys(newRouterData)
    //   .sort((a, b) => a.length - b.length)
    //   .reduce((result: any, currentKey) => {
    //     return {
    //       ...result,
    //       [currentKey]: newRouterData[currentKey],
    //     };
    //   }, {});
  };

  var initialState = {
    loading: false,
    microStatusMap: {},
    microModuleScriptMap: null,
    waitLoadMicroModules: []
  };
  var namespace = NAMESPACE;
  var extraReducers = _defineProperty({}, namespace, function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var _ref8 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref8.type,
      payload = _ref8.payload;
    if (!payload) {
      return state;
    }
    var ret;
    switch (type) {
      case UPDATE_MICRO_STATUS:
        var waitLoadMicroModules = state.waitLoadMicroModules;
        var newMicroLoadedMap = _objectSpread({}, state.microStatusMap);
        var _payload = payload;
        _payload.microModules.forEach(function (packageName) {
          newMicroLoadedMap[packageName] = _payload.status;
        });
        var newWaitLoadMicroModules = waitLoadMicroModules;
        if (_payload.status === 'LOADED') {
          newWaitLoadMicroModules = waitLoadMicroModules.filter(function (packageName) {
            return !_payload.microModules.includes(packageName);
          });
        }
        ret = _objectSpread(_objectSpread({}, state), {}, {
          microStatusMap: newMicroLoadedMap,
          waitLoadMicroModules: newWaitLoadMicroModules,
          loading: _payload.status === 'PENDING'
        });
        break;
      case UPDATE_STATE:
        ret = _objectSpread(_objectSpread({}, state), payload);
        break;
      default:
        ret = state;
        break;
    }
    return ret;
  });
  var handlePathNameQueue = [];
  var allMicroLoaded = false;
  var _isLoadMicro = function _isLoadMicro(packageInfo, pathname) {
    if (isLoadMicro) {
      if (isLoadMicro(packageInfo, pathname)) {
        return true;
      }
      return false;
    }
    if (!packageInfo.registerRegex) {
      return true;
    }
    if (new RegExp(packageInfo.registerRegex).test(pathname)) {
      return true;
    }
  };
  var handleLoadMicro = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref9) {
      var dispatch, getState, noShowLoading, allState, _ref11, microModuleScriptMap, waitLoadMicroModules, pathname, loadPackage, microDataRoute, oldRouterData, newRouterData, currentPathname;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              dispatch = _ref9.dispatch, getState = _ref9.getState, noShowLoading = _ref9.noShowLoading;
              if (!handleLoadMicroing) {
                _context8.next = 5;
                break;
              }
              return _context8.abrupt("return");
            case 5:
              handleLoadMicroing = true;
            case 6:
              allState = getState();
              _ref11 = allState[namespace], microModuleScriptMap = _ref11.microModuleScriptMap, waitLoadMicroModules = _ref11.waitLoadMicroModules;
              if (!(microModuleScriptMap === null)) {
                _context8.next = 12;
                break;
              }
              handleLoadMicroing = false;
              handleLoadMicroPending = null;
              return _context8.abrupt("return");
            case 12:
              if (!(waitLoadMicroModules.length === 0)) {
                _context8.next = 18;
                break;
              }
              allMicroLoaded = true;
              handleLoadMicroing = false;
              handleLoadMicroPending = null;
              setTimeout(function () {
                allState = getState();
                var currentPathname = allState.routing.location.pathname;
                tabListen(currentPathname);
              }, 0);
              return _context8.abrupt("return");
            case 18:
              loadPackage = [];
              while (handlePathNameQueue.length) {
                // await delay(0);
                // console.log(handlePathNameQueue);
                pathname = handlePathNameQueue.pop();
                waitLoadMicroModules.forEach(function (packageName) {
                  var packageInfo = microModuleScriptMap[packageName];
                  if (!packageInfo) {
                    return;
                  }
                  if (!pathname) {
                    return;
                  }
                  if (_isLoadMicro(packageInfo, pathname)) {
                    loadPackage.push(packageName);
                    return;
                  }
                });
              }
              loadPackage = _uniq(loadPackage);
              if (!(loadPackage.length > 0)) {
                _context8.next = 43;
                break;
              }
              _context8.prev = 22;
              dispatch({
                type: UPDATE_MICRO_STATUS,
                payload: {
                  microModules: loadPackage,
                  status: 'PENDING'
                }
              });
              if (!noShowLoading) {
                if (setMicroLoading) {
                  setMicroLoading(true);
                } else {
                  dispatch({
                    type: 'global/showLayoutPageLoading'
                  });
                }
              }
              _context8.next = 27;
              return getMicroModuleRouters({
                microModules: loadPackage,
                microModuleScriptMap: microModuleScriptMap
              });
            case 27:
              microDataRoute = _context8.sent;
              // 加载卡片等信息， 可以延后加载, 不需要阻塞首屏
              setTimeout(function () {
                loadCustomizeConfig({
                  microModuleScriptMap: microModuleScriptMap,
                  packageNames: loadPackage
                });
              }, 1500);
              allState = getState();
              oldRouterData = allState.global.routerData;
              newRouterData = overloadRouterData(oldRouterData, microDataRoute);
              dispatch({
                type: 'global/updateState',
                payload: {
                  routerData: newRouterData
                }
              });
              _context8.next = 38;
              break;
            case 35:
              _context8.prev = 35;
              _context8.t0 = _context8["catch"](22);
              console.error(_context8.t0);
            case 38:
              dispatch({
                type: UPDATE_MICRO_STATUS,
                payload: {
                  microModules: loadPackage,
                  status: 'LOADED'
                }
              });
              allState = getState();
              currentPathname = allState.routing.location.pathname;
              tabListen(currentPathname);
              if (!noShowLoading) {
                setTimeout(function () {
                  if (!handleLoadMicroing) {
                    if (setMicroLoading) {
                      setMicroLoading(false);
                    } else {
                      dispatch({
                        type: 'global/hideLayoutPageLoading'
                      });
                    }
                  }
                }, 10);
              }
            case 43:
              handleLoadMicroing = false;
              handleLoadMicroPending = null;
            case 45:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[22, 35]]);
    }));
    return function handleLoadMicro(_x9) {
      return _ref10.apply(this, arguments);
    };
  }();
  var onAction = function onAction(_ref12) {
    var dispatch = _ref12.dispatch,
      getState = _ref12.getState;
    return function (next) {
      return function (action) {
        var pathname = '';
        switch (action.type) {
          // 来自redux-router 内部
          case LOCATION_CHANGE_ACTION_TYPE:
            if (allMicroLoaded) {
              break;
            }
            pathname = action.payload.pathname;
            if (!handlePathNameQueue.includes(pathname)) {
              handlePathNameQueue.push(pathname);
              handleLoadMicroPending = handleLoadMicro({
                dispatch: dispatch,
                getState: getState
              });
            }
            break;
          case START_LISTEN_PATHNAME:
            if (handlePathNameQueue.length) {
              handleLoadMicroPending = handleLoadMicro({
                dispatch: dispatch,
                getState: getState
              });
            }
            break;
          case LOAD_MICRO_MODULE_FROM_PATHNAME:
            pathname = action.payload.pathname;
            handlePathNameQueue.push(pathname);
            handleLoadMicroPending = handleLoadMicro({
              dispatch: dispatch,
              getState: getState,
              noShowLoading: true
            });
            break;
          case 'global/showLayoutPageLoading':
          case 'global/hideLayoutPageLoading':
            var allState = getState();
            var _allState$global = allState.global,
              menuLoad = _allState$global.menuLoad,
              routerData = _allState$global.routerData,
              refreshMenuTabsKeyMap = _allState$global.refreshMenuTabsKeyMap;
            var activeTabKey = menuLoad ? allState.global.activeTabKey : allState.routing.location.pathname;
            if (!refreshMenuTabsKeyMap) {
              return dispatch({
                type: 'global/updateState',
                payload: {
                  layoutLoading: action.type === 'global/showLayoutPageLoading'
                }
              });
            } else {
              if (action.type === 'global/showLayoutPageLoading') {
                if (!routerData[activeTabKey]) {
                  refreshMenuTabsKeyMap.set(activeTabKey, uuid());
                  return dispatch({
                    type: 'global/updateState',
                    payload: {
                      // todo: tabs  需要 loading tabs
                      routerData: _objectSpread(_objectSpread({}, routerData), {}, _defineProperty({}, activeTabKey, {
                        component: function component() {
                          return /*#__PURE__*/React.createElement(_Spin, null);
                        },
                        path: activeTabKey,
                        exact: false,
                        pathRegexp: pathToRegexp(activeTabKey),
                        key: activeTabKey,
                        _isLoadingLayout: true
                      }))
                    }
                  });
                }
              }
              if (action.type === 'global/hideLayoutPageLoading') {
                if (activeTabKey !== '/workplace') {
                  refreshMenuTabsKeyMap.set(activeTabKey, uuid());
                }
                var newRouterData = _objectSpread({}, routerData);
                var hasChange = false;
                Object.keys(newRouterData).forEach(function (key) {
                  if (newRouterData[key]._isLoadingLayout) {
                    hasChange = true;
                    delete newRouterData[key];
                  }
                });
                if (activeTabKey === '/workplace' && !hasChange) {
                  return {
                    type: 'global/noop'
                  };
                }
                return dispatch({
                  type: 'global/updateState',
                  payload: {
                    routerData: newRouterData,
                    refreshMenuTabsKeyMap: new Map(_toConsumableArray(refreshMenuTabsKeyMap.entries()))
                  }
                });
              }
            }
            return {
              type: 'global/noop'
            };
          default:
            break;
        }
        return next(action);
      };
    };
  };
  var isInited = false;
  var onEffect = function onEffect(effect, _ref13, _, actionType) {
    var call = _ref13.call,
      put = _ref13.put,
      select = _ref13.select;

    // 来自hzero-front
    if (
    // 默认路由
    actionType === 'global/baseLazyInit' ||
    // 免权限(登陆)路由
    actionType === 'global/publicLazyInit' ||
    // 需要权限 但是没有左侧菜单等
    actionType === 'global/pubLazyInit' || actionType === 'global/privateLazyInit') {
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var microModuleScriptMap,
          allPackages,
          currentPathName,
          isInitLoad,
          initMicroModules,
          waitLoadMicroModules,
          microDataRoute,
          oldRouterData,
          newRouterData,
          currentPathname,
          _args9 = arguments;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (isInited) {
                  _context9.next = 7;
                  break;
                }
                if (!setMicroLoading) {
                  _context9.next = 5;
                  break;
                }
                setMicroLoading(true);
                _context9.next = 7;
                break;
              case 5:
                _context9.next = 7;
                return put({
                  type: 'global/showLayoutPageLoading'
                });
              case 7:
                _context9.next = 9;
                return effect.apply(void 0, _args9);
              case 9:
                if (!isInited) {
                  _context9.next = 11;
                  break;
                }
                return _context9.abrupt("return");
              case 11:
                // 是否全部加载了
                allMicroLoaded = false;
                microModuleScriptMap = {};
                _context9.prev = 13;
                _context9.next = 16;
                return call(getMicroModuleMapConfig);
              case 16:
                microModuleScriptMap = _context9.sent;
                _context9.next = 22;
                break;
              case 19:
                _context9.prev = 19;
                _context9.t0 = _context9["catch"](13);
                console.error(_context9.t0);
              case 22:
                _context9.next = 24;
                return put({
                  type: UPDATE_STATE,
                  payload: {
                    microModuleScriptMap: microModuleScriptMap
                  }
                });
              case 24:
                allPackages = Object.keys(microModuleScriptMap);
                _context9.next = 27;
                return select(function (state) {
                  return state.global.activeTabKey;
                });
              case 27:
                currentPathName = _context9.sent;
                if (currentPathName === '/') {
                  currentPathName = '/workplace';
                }
                isInitLoad = function isInitLoad(packageInfo) {
                  return packageInfo.initLoad === true || _isLoadMicro(packageInfo, currentPathName);
                }; // 初次需要加载的模块

                initMicroModules = allPackages.filter(function (packageName) {
                  return isInitLoad(microModuleScriptMap[packageName]);
                });
                if (window.location.pathname.includes('workplace')) {
                  // 加载卡片等信息， 可以延后加载, 不需要阻塞首屏
                  setTimeout(function () {
                    loadCustomizeConfig({
                      microModuleScriptMap: microModuleScriptMap,
                      packageNames: _toConsumableArray(initMicroModules)
                    });
                  }, 1000);
                }
                setTimeout(function () {
                  loadCustomizeConfig({
                    microModuleScriptMap: microModuleScriptMap,
                    packageNames: Object.keys(microModuleScriptMap)
                  });
                }, 15000); // 懒加载的模块

                waitLoadMicroModules = allPackages.filter(function (packageName) {
                  return !isInitLoad(microModuleScriptMap[packageName]);
                });
                _context9.next = 36;
                return put({
                  type: UPDATE_STATE,
                  payload: {
                    initMicroModules: initMicroModules,
                    waitLoadMicroModules: waitLoadMicroModules
                  }
                });
              case 36:
                if (!(initMicroModules.length > 0)) {
                  _context9.next = 60;
                  break;
                }
                _context9.prev = 37;
                _context9.next = 40;
                return put({
                  type: UPDATE_MICRO_STATUS,
                  payload: {
                    microModules: initMicroModules,
                    status: 'PENDING'
                  }
                });
              case 40:
                _context9.next = 42;
                return call(getMicroModuleRouters, {
                  microModules: initMicroModules,
                  microModuleScriptMap: microModuleScriptMap
                });
              case 42:
                microDataRoute = _context9.sent;
                _context9.next = 45;
                return select(function (state) {
                  return state.global.routerData;
                });
              case 45:
                oldRouterData = _context9.sent;
                newRouterData = overloadRouterData(oldRouterData, microDataRoute); // 更新路由表

                _context9.next = 49;
                return put({
                  type: 'global/updateState',
                  payload: {
                    routerData: newRouterData
                  }
                });
              case 49:
                _context9.next = 51;
                return select(function (state) {
                  return state.routing.location.pathname;
                });
              case 51:
                currentPathname = _context9.sent;
                tabListen(currentPathname);
                _context9.next = 58;
                break;
              case 55:
                _context9.prev = 55;
                _context9.t1 = _context9["catch"](37);
                console.log(_context9.t1);
              case 58:
                _context9.next = 60;
                return put({
                  type: UPDATE_MICRO_STATUS,
                  payload: {
                    microModules: initMicroModules,
                    status: 'LOADED'
                  }
                });
              case 60:
                if (!setMicroLoading) {
                  _context9.next = 64;
                  break;
                }
                setMicroLoading(false);
                _context9.next = 66;
                break;
              case 64:
                _context9.next = 66;
                return put({
                  type: 'global/hideLayoutPageLoading'
                });
              case 66:
                _context9.next = 68;
                return put({
                  type: START_LISTEN_PATHNAME
                });
              case 68:
                isInited = true;
              case 69:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[13, 19], [37, 55]]);
      });
    }
    return effect;
  };
  var onReducer = function onReducer(reducer) {
    return function (state, action) {
      if (action.type === 'global/updateState') {
        var routerData = state.global.routerData;
        if (action.payload.routerData) {
          if (action.payload.menuLoad) {
            routerData = _objectSpread(_objectSpread({}, routerData), action.payload.routerData);
          } else {
            routerData = action.payload.routerData;
          }
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          global: _objectSpread(_objectSpread(_objectSpread({}, state.global), action.payload), {}, {
            routerData: routerData
          })
        });
      }
      return reducer(state, action);
    };
  }; // dva插件

  var hooks = {
    onAction: onAction,
    onEffect: onEffect,
    onReducer: onReducer,
    extraReducers: extraReducers
  };
  return hooks;
};
var loadMicroModuleFromPathname = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref14) {
    var pathname;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            pathname = _ref14.pathname;
            if (pathname) {
              window.dvaApp._store.dispatch({
                type: 'microModule/LOAD_MICRO_MODULE_FROM_PATHNAME',
                payload: {
                  pathname: pathname
                }
              });
            }
          case 2:
            if (!handleLoadMicroing) {
              _context10.next = 7;
              break;
            }
            _context10.next = 5;
            return handleLoadMicroPending;
          case 5:
            _context10.next = 2;
            break;
          case 7:
            return _context10.abrupt("return");
          case 8:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return function loadMicroModuleFromPathname(_x10) {
    return _ref15.apply(this, arguments);
  };
}();
export { loadMicroModuleFromPathname };
export default bootstrap;